export const SAVE_PREFERENCES = 'user/SAVE_PREFERENCES';
export const UPDATE_PREFERENCES = 'user/UPDATE_PREFERENCES';
export const SAVE_PREFERENCES_FAIL = 'user/SAVE_PREFERENCES_FAIL';
export const DO_NOT_SET_PREFERENCE = 'user/DO_NOT_SET_PREFERENCE';
export const REMOVE_PREFERENCES = 'user/REMOVE_PREFERENCES';

export const savePreferences = ({ id, product_defaults }) => {
    return {
        type: SAVE_PREFERENCES,
        value: { id, product_defaults }
    };
};

export const removePreferences = (id) => {
    return {
        type: REMOVE_PREFERENCES,
        value: id
    };
};


export const doNotSetPreference = ({ id, product_defaults }) => {
    return {
        type: DO_NOT_SET_PREFERENCE,
        value: { id, product_defaults }
    };
};

export const updatePreferences = ({ id, product_defaults }) => {
    return {
        type: UPDATE_PREFERENCES,
        value: { id, product_defaults }
    };
};

export const savePreferencesFail = ({ id, product_defaults }) => {
    return {
        type: SAVE_PREFERENCES_FAIL,
        value: { id, product_defaults }
    };
};
